<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="환산표"
        tableId="accidentSeq"
        :columns="grid.columns"
        :data="grid.data"
        :usePaging="false"
        :columnSetting="false"
      >
      </c-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hazop-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '항목',
            align: 'left',
            style: 'width:50%',
            sortable: false
          },
          {
            name: 'col2',
            field: 'col2',
            label: '최고실배점',
            align: 'center',
            sortable: false
          },
          {
            name: 'col3',
            field: 'col3',
            label: '환산계수',
            align: 'center',
            sortable: false
          },
          {
            name: 'col4',
            field: 'col4',
            label: '최고환산점수',
            align: 'center',
            sortable: false
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.grid.data = [
        {
          col1: '안전경영과 근로자참여',
          col2: '370',
          col3: '0.057',
          col4: '21',
        },
        {
          col1: '공정안전자료',
          col2: '70',
          col3: '0.071',
          col4: '5',
        },
        {
          col1: '공정위험성평가',
          col2: '130',
          col3: '0.041',
          col4: '5.5',
        },
        {
          col1: '안전운전 지침과 절차',
          col2: '80',
          col3: '0.05',
          col4: '4',
        },
        {
          col1: '설비의 점검 검사 보수계획, 유지계획 및 지침',
          col2: '120',
          col3: '0.046',
          col4: '5.5',
        },
        {
          col1: '안전작업허가 및 절차',
          col2: '80',
          col3: '0.106',
          col4: '8.5',
        },
        {
          col1: '도급업체 안전관리',
          col2: '100',
          col3: '0.08',
          col4: '8',
        },
        {
          col1: '공정운전에 대한 교육훈련',
          col2: '70',
          col3: '0.071',
          col4: '5',
        },
        {
          col1: '가동전 점검지침',
          col2: '60',
          col3: '0.05',
          col4: '3',
        },
        {
          col1: '변경요소 관리계획',
          col2: '70',
          col3: '0.1',
          col4: '7',
        },
        {
          col1: '자체감사',
          col2: '90',
          col3: '0.044',
          col4: '4',
        },
        {
          col1: '안전사고조사 지침',
          col2: '90',
          col3: '0.033',
          col4: '3',
        },
        {
          col1: '비상조치계획',
          col2: '80',
          col3: '0.044',
          col4: '3.5',
        },
        {
          col1: '현장확인',
          col2: '210',
          col3: '0.081',
          col4: '17',
        },
      ];
    },
  }
};
</script>
